import { ModuleDropdownProps } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';

import { useAbility } from '~/app/contexts/AbilityContext';
import { Icon } from '~/shared/components/';

export function useModuleItems() {
  const { t } = useTranslate();
  const ability = useAbility();

  const items: ModuleDropdownProps['items'] = [];

  if (
    ability.can('view', 'Cheershub') &&
    process.env.NEXT_PUBLIC_CHEERSHUB_MODULES_DROPDOWN_URL
  ) {
    items.push({
      label: t('menu.cheershub'),
      subtitle: t('menu.cheershub'),
      icon: <Icon.Cheershub color="#171717" size={16} />,
      url: process.env.NEXT_PUBLIC_CHEERSHUB_MODULES_DROPDOWN_URL,
    });
  }

  if (process.env.NEXT_PUBLIC_WORKDAY_URL) {
    items.push({
      label: t('menu.workday'),
      subtitle: t('menu.workday'),
      icon: <Icon.Workday color="#171717" size={16} />,
      url: process.env.NEXT_PUBLIC_WORKDAY_URL,
    });
  }

  return { items };
}
